import { usePremiumCurrencyFormatter } from '@wix/premium-react-text';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { CurrentPlanInOfferingMode } from '../../enums';
import { RootStore, withInjectedRootStore } from '../../providers';
import {
  FlowType,
  PaymentCycle_BIMap,
} from '../../services/BiLogger/BiLoggerTypes';
import { ChangePlanModal } from '../ChangePlan/advanced/ChangePlanModal/ChangePlanModal';
import { SwitchPlanHeader } from './advanced/SwitchPlanHeader';
import { ViewCurrentPlanModal } from './advanced/ViewCurrentPlanModal';

export interface SwitchPlanNotificationBarProps {
  rootStore: RootStore;
}

export const SwitchPlanNotificationBarComp: React.FC<SwitchPlanNotificationBarProps> = ({
  rootStore,
}) => {
  const { t } = useTranslation();
  const {
    currentPlanInOfferingMode,
    isChangePlanToastMode,
    appContext,
    isChangePlan,
    isSecondUpgrade,
  } = rootStore.appStore;
  const { biLogger } = appContext;
  const currentPlanDetails = appContext.currentPlanDetails!;
  const [currencyToString] = usePremiumCurrencyFormatter();
  const [isCurrentPlanModalOpened, setCurrentPlanModalOpened] = React.useState(
    false,
  );

  const getHeaderText = () => {
    const headerKeys = {
      current: 'change_plan.header.your_current_plan_advanced',
      notIncluded: 'change_plan.header.plan_not_included_advanced',
    };
    const cycle = t(
      `change_plan.current_plan_banner.${currentPlanDetails.paymentCycle}.billed`,
    );
    return currentPlanInOfferingMode ===
      CurrentPlanInOfferingMode.ProductPartialMatch
      ? t(headerKeys.current, {
          price: currencyToString(currentPlanDetails.pricePerMonth),
          cycle,
          name: currentPlanDetails.planName,
        })
      : t(headerKeys.notIncluded, {
          price: currencyToString(currentPlanDetails.pricePerMonth),
          product: currentPlanDetails.planName,
        });
  };

  const getFlowType = (): FlowType => {
    return isSecondUpgrade
      ? FlowType.Upgrade
      : isChangePlan
      ? FlowType.ChangePlan
      : FlowType.Regular;
  };

  const openModal = () => {
    biLogger.logCurrentPlanModalOpened({
      changePlanType: currentPlanInOfferingMode,
      currentProductId: currentPlanDetails.planId,
      currentCycleId: PaymentCycle_BIMap[currentPlanDetails.paymentCycle],
      packageId: currentPlanDetails.userPackageGuid,
      flowType: getFlowType(),
    });

    setCurrentPlanModalOpened(true);
  };

  const closeModal = () => {
    setCurrentPlanModalOpened(false);
  };
  const label = getHeaderText();
  return (
    <>
      {isChangePlanToastMode && (
        <SwitchPlanHeader label={label} onClick={openModal} />
      )}
      <ViewCurrentPlanModal
        isOpen={isCurrentPlanModalOpened}
        closeModal={closeModal}
      />
      <ChangePlanModal />
    </>
  );
};

export const SwitchPlanNotificationBar = withInjectedRootStore(
  SwitchPlanNotificationBarComp,
);
